import { defineComponent as _defineComponent } from 'vue'


interface IProps {
  description: string;
  number: string | number;
  classes?: string[];
  noBorder?: boolean;
  hasIcon?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AtomInfoCard',
  props: {
    description: { type: String, required: true },
    number: { type: [String, Number], required: true },
    classes: { type: Array, required: false },
    noBorder: { type: Boolean, required: false },
    hasIcon: { type: Boolean, required: false, default: false }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

const props = __props;



const __returned__ = { props }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})